import React from 'react'
import { Outlet } from 'react-router-dom'
import { Icon, IconLibrary, NavBar, useAppLinksNavSection } from '../../../components'
import '../index.css'

const App = ({ appName }) => {

  // Länkar live in the sidebar rather than as a right rail on Hem — null while
  // loading, and for a non-admin with no links, in which case no section renders.
  const lankar = useAppLinksNavSection(appName)

  const links = [
    // Hem is the person list itself, so there is no separate "Personer" entry — it would
    // be a second link to the same page.
    {
      type: "link",
      relativePath: "",
      label: "Hem",
      icon: <Icon name="home" />,
    },
    {
      type: "section",
      label: "Vyer",
      links: [
        {
          type: "link",
          relativePath: "companies",
          label: "Företag",
          icon: <IconLibrary name="company" />,
        },
        {
          type: "link",
          relativePath: "networking",
          label: "Nätverkande",
          icon: <IconLibrary name="timeline" />,
        },
      ],
    },
    ...(lankar ? [lankar] : []),
  ]

  return (
    <div className={"app-container" + (appName ? " " + appName : "")}>

      <NavBar links={links} appName={appName} />

      <div className="app-content">
        <Outlet context={appName} />
      </div>

    </div>
  )
}

export default App
